import { getAbTestLifecycleState } from '@bridebook/toolbox/src/ab-testing/lib/selectors';
import { getIsE2E } from '@bridebook/toolbox/src/e2e/get-is-e2e';
import { useABTestV2Integration } from '@bridebook/web/lib/ab-tests/hooks/use-ab-test-v2-integration';
import {
  AI_WEDDING_PLANNER_TEST_ID,
  isAiWeddingPlannerVariantEnabled,
  isPlannerAvailableForCountry,
} from '@bridebook/web/lib/ai-planner/availability';
import type { IApplicationState } from '@bridebook/web/lib/types';
import { useSelector } from '@bridebook/web/lib/utils';

export const getVariant_AiWeddingPlanner = (state: IApplicationState) =>
  getAbTestLifecycleState(state, AI_WEDDING_PLANNER_TEST_ID)?.variant;

// E2E runs never resolve a test, so there the planner shows as variant 1 would.
export const getIsAiWeddingPlannerEnabled = (state: IApplicationState) =>
  getIsE2E() || isAiWeddingPlannerVariantEnabled(getVariant_AiWeddingPlanner(state));

// Variant 2: the panel opens by default and new users onboard in the conversation.
export const getIsAiWeddingPlannerConversational = (state: IApplicationState) =>
  getVariant_AiWeddingPlanner(state) === '2';

// True once the cohort is known, or when there is none to wait for in a market without the planner.
export const getIsAiWeddingPlannerResolved = (state: IApplicationState) => {
  const status = getAbTestLifecycleState(state, AI_WEDDING_PLANNER_TEST_ID)?.status;
  return (
    (status !== undefined && status !== 'loading') ||
    !isPlannerAvailableForCountry(state.weddings.profile.l10n?.country)
  );
};

// Cohorted only in markets with the planner, once the wedding's country is known.
export const useABTest_AiWeddingPlanner = () => {
  const country = useSelector((state) => state.weddings.profile.l10n?.country);
  useABTestV2Integration({
    testId: AI_WEDDING_PLANNER_TEST_ID,
    triggerCondition: country ? isPlannerAvailableForCountry(country) : undefined,
  });
};
